module.exports = __webpack_public_path__ + "img/img_head@2x.785ee677.png";